/**
 * Normalize an email address for cache key comparison (feature 090).
 *
 * Trims whitespace and lowercases the input so callers can treat
 * `"Jane.Doe@CONTOSO.com"` and `"  jane.doe@contoso.com  "` as the
 * same key.
 */
export function normalizeEmail(email: string | undefined | null): string {
  if (!email) return '';
  return email.trim().toLowerCase();
}
